// Eigenes Icon/Logo für fair_invoices — bewusst andere Farbfamilie (Blau/Gold)
// als fair_products/fair_stores (Bernstein), damit die App auf Kacheln/Tabs
// klar unterscheidbar bleibt. Reines inline-SVG, kein externes Asset.
export default function InvoiceLogo({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <rect width="100" height="100" rx="16" fill="#2f5d8a" />
      <path d="M26,14 H62 L74,26 V86 H26 Z" fill="#ffffff" />
      <path d="M62,14 L74,26 H62 Z" fill="#c9d9e8" />
      <rect x="34" y="38" width="32" height="5" rx="2.5" fill="#c9d9e8" />
      <rect x="34" y="50" width="32" height="5" rx="2.5" fill="#c9d9e8" />
      <rect x="34" y="62" width="20" height="5" rx="2.5" fill="#c9d9e8" />
      <circle cx="70" cy="72" r="16" fill="#e0a940" stroke="#ffffff" strokeWidth="3" />
      <path d="M63,72 L68,78 L79,65" fill="none" stroke="#ffffff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
